import { Controller } from "@hotwired/stimulus"

// Превью выбранного файла (фото/видео) прямо в форме, без загрузки на сервер.
export default class extends Controller {
  static targets = ["input", "output"]

  show() {
    this.outputTarget.innerHTML = ""
    const file = this.inputTarget.files[0]
    if (!file) return
    const url = URL.createObjectURL(file)
    if (file.type.startsWith("image/")) {
      const img = document.createElement("img")
      img.src = url; img.style.maxWidth = "160px"; img.className = "img-thumbnail"
      this.outputTarget.appendChild(img)
    } else if (file.type.startsWith("video/")) {
      const v = document.createElement("video")
      v.src = url; v.controls = true; v.style.maxWidth = "220px"
      this.outputTarget.appendChild(v)
    }
  }
}
